export default function ResizeImage() {
    this.resize = function(file, callback) {
        let img = new Image();
        img.onload = function () {
            resizeImage(img, function (fileResized, dataUrl) {
                callback(fileResized, dataUrl);
                
            }, 800 * 3, 200 * 3);
        };
        let _URL = window.URL || window.webkitURL;
        img.src = _URL.createObjectURL(file);
    };
}


function resizeImage(img, callback, max_width, max_height) {
    let canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    let ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);

    let MAX_WIDTH = max_width || 1200 * 3;
    let MAX_HEIGHT = max_height || 800 * 3;
    let width = img.width;
    let height = img.height;

    if (width > height) {
        if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
        }
    } else {
        if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
        }
    }
    canvas.width = width;
    canvas.height = height;
    ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, width, height);

    let dataurl = canvas.toDataURL("image/jpeg");
    let blobFile = dataURLtoBlob(dataurl);


    callback(blobFile, dataurl);
}

function dataURLtoBlob(dataurl) {
    let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}
